$(function() {

    /**
     *
     */
    var graph_clicks = function() {
        var ctx = document.getElementById('chart-clicks').getContext('2d');
        var chart = new Chart(ctx, {
            type: 'line',
            data: {
                labels: chart_labels,
                datasets : [
                    {
                        label: 'Clicks',
                        fill : false,
                        strokeColor : '#0073f9',
                        pointColor : '#fff',
                        pointStrokeColor : '#0073f9',
                        data : chart_clicks,
                        tension: 0,
                        borderColor: '#0073f9',
                        borderWidth: 2,
                        pointRadius: 5,
                        pointHoverBackgroundColor: '#ffffff',
                        pointBackgroundColor: '#ffffff',
                        pointBorderColor: '#0073f9',
                        pointHitRadius: 3,
                        pointHoverRadius: 8
                    }
                ]
            },
            options: {
                animation: false,
                scales: {
                    yAxes: [{
                        ticks: {
                            beginAtZero: true,
                            userCallback: function(label, index, labels) {
                                // Integer labels only
                                if (Math.floor(label) === label) {
                                    return label;
                                }
                            }
                        }
                    }]
                },
                legend: {
                    display: false
                },
                tooltips: {
                    callbacks: {
                        title: function(tooltipItem, data) {
                            return data['labels'][tooltipItem[0]['index']];
                        },
                        label: function (t, d) {
                            if (t.datasetIndex === 0) {
                                return t.yLabel + ' clicks';
                            }
                        }
                    },
                    backgroundColor: '#FFF',
                    titleFontColor: '#222222',
                    bodyFontColor: '#777777',
                    displayColors: false,
                    position: 'nearest',
                    mode: 'index',
                    intersect: false,
                    yPadding: 10,
                    xPadding: 10,
                    caretSize: 8,
                    borderColor: '#777777',
                    borderWidth: 1
                }
            }
        });
    };

    /**
     * A dog in Polish is PIES!
     */
    var make_pie = function(pies, pie_data, pie_color, pie_tip_title, pie_tip_count) {
        var data = pie_data;
        var color = pie_color;
        var tip_title = pie_tip_title;
        var tip_count = pie_tip_count;

        var width = 300,
            height = 300,
            radius = height / 2;

        var arc = d3.svg.arc()
            .innerRadius(radius - 50)
            .outerRadius(radius);

        var pie = d3.layout.pie()
            .padAngle(0);

        var svg = d3.select(pies).append('svg')
            .attr('width', width)
            .attr('height', height)
            .append('g')
            .attr('transform', 'translate(' + width / 2 + ',' + height / 2 + ')');

        var paths = svg.selectAll('path')
            .data(pie(data))
            .enter().append('path')
            .style('fill', function(d, i) {
                return color[i];
            })
            .attr('d', arc);
        for(var i = 0; i < paths[0].length; i++) {
            $(paths[0][i]).data('powertip', '<span class="color-gray">' + tip_title[i] + '</span> <br/> ' + tip_count[i]);
            $(paths[0][i]).powerTip({
                followMouse: true
            });
        }
    };

    /**
     *
     */
    var map_clicks = function() {
        var map = new Datamap({
            element: document.getElementById('world-map'),
            projection: 'mercator',
            fills: {
                defaultFill: '#ffffff',
                percent10: '#e6f1fe',
                percent20: '#dbebfe',
                percent30: '#bddbfd',
                percent40: '#a2ccfd',
                percent50: '#83bbfc',
                percent60: '#63a9fb',
                percent70: '#4599fb',
                percent80: '#298afa',
                percent90: '#127df9',
                percent100: '#0073f9'
            },
            data: map_data,
            geographyConfig: {
                borderWidth: 1,
                borderColor: '#0073f9',
                highlightOnHover: false,
                popupTemplate: function(geography, data) {
                    if (data && data.clicks) {
                        return '<div id="map-tooltip">' + geography.properties.name + '<br/><span class="color-gray">' + data.clicks + ' clicks (' + data.percent + '%)</span></div>';
                    } else {
                        return '<div id="map-tooltip">' + geography.properties.name + '</div>';
                    }
                }
            }
        });
    };

    /**
     *
     */
    var load_stats = function(form) {
        var stats = form.find('.stats');
        var loading = form.find('.preloader-wrapper');

        stats.hide();
        loading.show();

        $.post(
            form.attr('action'),
            form.serialize(),
            function(response) {
                loading.hide();
                stats.replaceWith($(response.content)).show();

                if (response.status == 'error') {
                    //info(response.message);
                    return;
                }

                if ($('#chart-clicks').length) {
                    graph_clicks();
                }
                if ($('#pie-referrers').length) {
                    make_pie('#pie-referrers', pie_data_referrers, pie_color_referrers, pie_tip_title_referrers, pie_tip_count_referrers);
                }
                if ($('#pie-languages').length) {
                    make_pie('#pie-languages', pie_data_languages, pie_color_languages, pie_tip_title_languages, pie_tip_count_languages);
                }
                if ($('#pie-devices').length) {
                    make_pie('#pie-devices', pie_data_devices, pie_color_devices, pie_tip_title_devices, pie_tip_count_devices);
                }
                if ($('#world-map').length) {
                    map_clicks();
                }
            },
            'json'
        );
    };

    /**
     *
     */
    $('.stats-nav').on('click', '[data-period]', function(e) {
        e.preventDefault();

        var form = $(this).closest('form');

        $(this).closest('ul').find('li').removeClass('active');
        $(this).closest('li').addClass('active');

        form.find('[name=period]').val($(this).data('period'));

        load_stats(form);
    });

    /**
     *
     */
    var stats_daterange = $('.stats-range input.daterange');
    if (stats_daterange.length) {
        stats_daterange.daterangepicker({
            locale: {
                format: 'MMM D, YYYY'
            },
            timePicker: false,
            opens: 'left',
            startDate: dr_init_range == 'day' ? moment() : moment().subtract(29, 'days'),
            endDate: moment(),
            //minDate: moment().subtract(1, 'month'),
            ranges: {
                'Today': [moment(), moment()],
                'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                'Last 7 Days': [moment().subtract(6, 'days'), moment()],
                'Last 30 Days': [moment().subtract(29, 'days'), moment()],
                //'This Month': [moment().startOf('month'), moment().endOf('month')],
                //'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
                'All time': [0, moment()]
            },
            applyClass: 'datepicker-buttonSubmit',
            cancelClass: 'datepicker-buttonCancel'
        })
        .on('change', function () {
            var form = $(this).closest('form');
            load_stats(form);
        })
        .trigger('change')
        ;
    }

    /**
     * Stats popups override
     */
    $('body').on('click', '[data-popup-stats]', function(e) {
        e.preventDefault();

        var popup_wrapper = $('#popup-wrapper');
        var popup_id = $(this).data('popup-stats');
        var popup = $(popup_id);

        if (popup_wrapper.find(popup_id).length) {
            popup_wrapper.find(popup_id).replaceWith(popup);
        }
        else {
            popup.appendTo(popup_wrapper);
        }

        if ($('.popup:visible').length) {
            changePopup(popup);
        }
        else {
            showPopup(popup);
        }
    })
    .on('click', '[data-popup-stats-expanded]', function(e) {
        e.preventDefault();

        var form = $($(this).data('form'));

        $.post(
            $(this).data('popup-stats-expanded'),
            form.serialize() + '&value=' + encodeURIComponent($(this).data('value')),
            function(response) {
                if (response.status == 'error') {
                    return;
                }

                var popup_wrapper = $('#popup-wrapper');
                var popup = $(response.content);
                var popup_id = popup.attr('id');

                if (popup_wrapper.find(popup_id).length) {
                    popup_wrapper.find(popup_id).replaceWith(popup);
                }
                else {
                    popup.appendTo(popup_wrapper);
                }

                if ($('.popup:visible').length) {
                    changePopup(popup);
                }
                else {
                    showPopup(popup);
                }
            },
            'json'
        );
    })
    ;

    /**
     *
     */
    $('.stats-form').on('click', '[data-stats-export]', function(e) {
        e.preventDefault();

        var form = $($(this).data('form'));

        $.post(
            form.attr('action') + '/export',
            form.serialize() + '&export=' + encodeURIComponent($(this).data('stats-export')),
            function(response) {
                if (response.status == 'error') {
                    return;
                }

                var blob = new Blob(response.data, {type: response.type});
                var url = URL.createObjectURL(blob);

                var a = document.createElement('a');
                a.href = url;
                a.download = response.name;
                a.click();
            },
            'json'
        );
    });
});
